import { Component } from 'react'
import ProductListingBaseForm from '../ProductListingBaseForm'
import CommonPage from '../../../containers/Proposal/Common/CommonPage'
import { withI13nWrapper } from '../../Common/I13nWrapper'

class Container extends Component {
  render () {
    return (
      <CommonPage>
        <ProductListingBaseForm
          key='form'
          {...this.props}
        />
      </CommonPage>
    )
  }
}

export default withI13nWrapper(Container)
